import React, { useEffect, useState } from "react";
import styles from "./CustomerAnalytics.module.css";
import DatePicker from "react-datepicker";
import { HiSearchCircle } from "react-icons/hi";
import {
  AiOutlineUser,
  AiOutlineReload,
  AiOutlineDollarCircle,
  AiOutlineTrophy,
} from "react-icons/ai";
import { FaShoppingBag, FaPercentage, FaMapMarkerAlt } from "react-icons/fa";
import myAxios from "../AxiosUrl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function CustomerAnalytics() {
  const [DateFrom, setDateFrom] = useState(new Date());
  DateFrom.setHours(0);
  DateFrom.setMinutes(0);
  DateFrom.setSeconds(0);

  const [DateTo, setDateTo] = useState(new Date());
  DateTo.setHours(0);
  DateTo.setMinutes(0);
  DateTo.setSeconds(0);

  const [DateSearch, setDateSearch] = useState(false);
  const [RefreshSe, setRefreshSe] = useState(1);
  const uid = localStorage.getItem("id");

  const [Totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setPageLimit] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [overallStats, setOverallStats] = useState({});
  const [repeatRate, setRepeatRate] = useState(0);
  const [cityDistribution, setCityDistribution] = useState([]);

  const [searchN, setSearchNum] = useState("");
  const [loading, setLoading] = useState(true);
  const [FilterDate, setFilterDate] = useState("Last Month");

  const getData = () => {
    setLoading(true);
    const Nurl = `get-customer-analytics?searchN=${searchN}&uid=${uid}&page=${page}&limit=${limit}&FilterDate=${FilterDate}&DateFrom=${DateFrom}&DateTo=${DateTo}&DateSearch=${DateSearch}`;
    myAxios
      .get(Nurl)
      .then((res) => {
        if (res.data.success) {
          setCustomers(res.data.data.customers || []);
          setTotalPage(res.data.data.total || 0);
          setOverallStats(res.data.data.overallStats || {});
          setRepeatRate(res.data.data.repeatRate || 0);
          setCityDistribution(res.data.data.cityDistribution || []);
        }
        setLoading(false);
        setDateSearch(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [FilterDate, RefreshSe, page, limit]);

  const formatCurrency = (amount) => {
    const formatted = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount || 0);
    return `৳ ${formatted}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const renderDataSkeleton = () => (
    <>
      {/* Skeleton Stats Cards */}
      <div className={styles["skeleton-stats-grid"]}>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={styles["skeleton-stat-card"]}>
            <div className={styles.skeleton} style={{width: '56px', height: '56px', borderRadius: '8px', flexShrink: 0}}></div>
            <div style={{flex: 1}}>
              <div className={styles.skeleton} style={{width: '80px', height: '22px', marginBottom: '8px'}}></div>
              <div className={styles.skeleton} style={{width: '100px', height: '14px'}}></div>
            </div>
          </div>
        ))}
      </div>

      {/* Skeleton Cities Chart */}
      <div className={styles["skeleton-cities-section"]}>
        <div className={styles.skeleton} style={{width: '220px', height: '20px', marginBottom: '20px'}}></div>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={styles["skeleton-chart-row"]}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <div className={styles.skeleton} style={{width: '28px', height: '16px'}}></div>
              <div className={styles.skeleton} style={{width: '70px', height: '16px'}}></div>
            </div>
            <div className={styles.skeleton} style={{width: `${90 - i * 12}%`, height: '32px', borderRadius: '8px'}}></div>
            <div className={styles.skeleton} style={{width: '60px', height: '14px'}}></div>
          </div>
        ))}
      </div>

      {/* Skeleton Table Header Bar */}
      <div className={styles["skeleton-table-header-bar"]}>
        <div className={styles.skeleton} style={{width: '180px', height: '20px'}}></div>
        <div className={styles.skeleton} style={{width: '160px', height: '16px'}}></div>
      </div>

      {/* Skeleton Table */}
      <div className={styles["skeleton-table-section"]}>
        <div className={styles["skeleton-table-head"]}>
          {['80px','50px','60px','60px','60px','55px','75px','65px','60px','70px','50px','65px','65px'].map((w, i) => (
            <div key={i} className={styles.skeleton} style={{width: w, height: '14px'}}></div>
          ))}
        </div>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className={styles["skeleton-table-row"]}>
            <div>
              <div className={styles.skeleton} style={{width: '100px', height: '16px', marginBottom: '6px'}}></div>
              <div className={styles.skeleton} style={{width: '80px', height: '12px'}}></div>
            </div>
            <div className={styles.skeleton} style={{width: '60px', height: '16px'}}></div>
            <div className={styles.skeleton} style={{width: '36px', height: '22px', borderRadius: '12px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '36px', height: '22px', borderRadius: '12px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '36px', height: '22px', borderRadius: '12px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '36px', height: '22px', borderRadius: '12px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '70px', height: '16px', marginLeft: 'auto'}}></div>
            <div className={styles.skeleton} style={{width: '65px', height: '16px', marginLeft: 'auto'}}></div>
            <div className={styles.skeleton} style={{width: '60px', height: '16px', marginLeft: 'auto'}}></div>
            <div className={styles.skeleton} style={{width: '45px', height: '16px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '50px', height: '22px', borderRadius: '12px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '70px', height: '14px'}}></div>
            <div className={styles.skeleton} style={{width: '70px', height: '14px'}}></div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className={styles["shopify-container"]}>
      {/* Filters Section - always visible */}
      <div className={styles["filters-section"]}>
        <div className={styles["filters-row"]}>
          <div className={styles["shopify-date-filter"]}>
            <select
              name="filterData"
              className={styles["shopify-select"]}
              value={FilterDate}
              onChange={(e) => setFilterDate(e.target.value)}
            >
              <option value="Today">Today</option>
              <option value="Yesterday">Yesterday</option>
              <option value="Last 7 Days">Last 7 Days</option>
              <option value="Last 30 Days">Last 30 Days</option>
              <option value="This Month">This Month</option>
              <option value="Last Month">Last Month</option>
              <option value="Custom Range">Custom Range</option>
            </select>
          </div>

          {FilterDate === "Custom Range" && (
            <>
              <div className={styles["shopify-input-group"]}>
                <label>From:</label>
                <DatePicker
                  selected={DateFrom}
                  className={styles["shopify-input"]}
                  onChange={(date) => setDateFrom(date)}
                  dateFormat="dd/MM/yyyy"
                />
              </div>

              <div className={styles["shopify-input-group"]}>
                <label>To:</label>
                <DatePicker
                  selected={DateTo}
                  className={styles["shopify-input"]}
                  onChange={(date) => setDateTo(date)}
                  dateFormat="dd/MM/yyyy"
                />
              </div>

              <button
                className={styles["shopify-btn-primary"]}
                onClick={() => {
                  setDateSearch(true);
                  setRefreshSe(RefreshSe + 1);
                }}
              >
                Apply Date
              </button>
            </>
          )}
        </div>

        {/* Search Bar */}
        <div className={styles["shopify-search-bar"]}>
          <input
            type="text"
            placeholder="Search by customer name, mobile, or city..."
            className={styles["shopify-search-input"]}
            value={searchN}
            onChange={(e) => setSearchNum(e.target.value)}
          />
          <button
            className={styles["shopify-btn-search"]}
            onClick={() => {
              setPage(1);
              setRefreshSe(RefreshSe + 1);
            }}
          >
            <HiSearchCircle size={24} />
            Search
          </button>
        </div>
      </div>

      {loading ? renderDataSkeleton() : (
        <>
          {/* Overall Stats Cards */}
          <div className={styles["stats-cards"]}>
            <div className={styles["stat-card"]}>
              <div className={styles["stat-icon"]}>
                <AiOutlineUser />
              </div>
              <div className={styles["stat-content"]}>
                <div className={styles["stat-value"]}>
                  {overallStats.uniqueCustomers || 0}
                </div>
                <div className={styles["stat-label"]}>Total Customers</div>
              </div>
            </div>

            <div className={styles["stat-card"]}>
              <div className={styles["stat-icon"]}>
                <FaShoppingBag />
              </div>
              <div className={styles["stat-content"]}>
                <div className={styles["stat-value"]}>
                  {overallStats.totalOrders || 0}
                </div>
                <div className={styles["stat-label"]}>Total Orders</div>
              </div>
            </div>

            <div className={styles["stat-card"]}>
              <div className={styles["stat-icon"]}>
                <AiOutlineDollarCircle />
              </div>
              <div className={styles["stat-content"]}>
                <div className={styles["stat-value"]}>
                  {formatCurrency(overallStats.totalRevenue || 0)}
                </div>
                <div className={styles["stat-label"]}>Total Revenue</div>
              </div>
            </div>

            <div className={styles["stat-card"]}>
              <div className={styles["stat-icon"]}>
                <AiOutlineDollarCircle />
              </div>
              <div className={styles["stat-content"]}>
                <div className={styles["stat-value"]}>
                  {formatCurrency(overallStats.avgOrderValue || 0)}
                </div>
                <div className={styles["stat-label"]}>Avg Order Value</div>
              </div>
            </div>

            <div className={styles["stat-card"]}>
              <div className={styles["stat-icon"]}>
                <FaPercentage />
              </div>
              <div className={styles["stat-content"]}>
                <div className={styles["stat-value"]}>
                  {repeatRate.toFixed(1)}%
                </div>
                <div className={styles["stat-label"]}>Repeat Customer Rate</div>
              </div>
            </div>
          </div>

          {/* Top Cities Section - Compact Bar Chart */}
          {cityDistribution.length > 0 && (
            <div className={styles["cities-section"]}>
              <h3 className={styles["section-title"]}>
                <FaMapMarkerAlt /> Top 5 Cities by Revenue
              </h3>
              <div className={styles["cities-chart"]}>
                {(() => {
                  const maxRevenue = Math.max(...cityDistribution.map(c => c.revenue));
                  return cityDistribution.slice(0, 5).map((city, index) => {
                    const percentage = (city.revenue / maxRevenue) * 100;
                    return (
                      <div key={index} className={styles["chart-row"]}>
                        <div className={styles["chart-label"]}>
                          <span className={styles["chart-rank"]}>#{index + 1}</span>
                          <span className={styles["chart-city"]}>{city._id || "Unknown"}</span>
                        </div>
                        <div className={styles["chart-bar-container"]}>
                          <div
                            className={styles["chart-bar"]}
                            style={{ width: `${percentage}%` }}
                          >
                            <span className={styles["chart-value"]}>
                              {formatCurrency(city.revenue)}
                            </span>
                          </div>
                        </div>
                        <div className={styles["chart-orders"]}>
                          {city.orderCount} {city.orderCount === 1 ? 'order' : 'orders'}
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
          )}

          {/* Customer Table */}
          {customers.length > 0 && (
            <>
              <div className={styles["table-header"]}>
                <h3 className={styles["section-title"]}>
                  <AiOutlineTrophy /> Customer Details
                </h3>
                <div className={styles["table-info"]}>
                  Showing {customers.length} of {Totalpage} customers
                </div>
              </div>

              <TableContainer component={Paper} className={styles["shopify-table"]}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Customer</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell align="center">Total Orders</TableCell>
                      <TableCell align="center">Delivered</TableCell>
                      <TableCell align="center">Cancelled</TableCell>
                      <TableCell align="center">Returned</TableCell>
                      <TableCell align="right">Total Revenue</TableCell>
                      <TableCell align="right">Total Profit</TableCell>
                      <TableCell align="right">Avg Order</TableCell>
                      <TableCell align="center">Delivery Rate</TableCell>
                      <TableCell align="center">Type</TableCell>
                      <TableCell>First Order</TableCell>
                      <TableCell>Last Order</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customers.map((customer, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <div className={styles["customer-info"]}>
                            <div className={styles["customer-name"]}>
                              {customer.customerName || "N/A"}
                            </div>
                            <div className={styles["customer-mobile"]}>
                              {customer.customerMobile}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>{customer.customerCity || "N/A"}</TableCell>
                        <TableCell align="center">
                          <span className={styles["badge-primary"]}>
                            {customer.totalOrders}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <span className={styles["badge-success"]}>
                            {customer.deliveredOrders}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <span className={styles["badge-danger"]}>
                            {customer.cancelledOrders}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <span className={styles["badge-warning"]}>
                            {customer.returnedOrders}
                          </span>
                        </TableCell>
                        <TableCell align="right">
                          <strong>{formatCurrency(customer.totalRevenue)}</strong>
                        </TableCell>
                        <TableCell align="right">
                          <strong className={styles["profit-text"]}>
                            {formatCurrency(customer.totalProfit)}
                          </strong>
                        </TableCell>
                        <TableCell align="right">
                          {formatCurrency(customer.avgOrderValue)}
                        </TableCell>
                        <TableCell align="center">
                          <span
                            className={
                              customer.deliveryRate >= 80
                                ? styles["rate-high"]
                                : customer.deliveryRate >= 50
                                ? styles["rate-medium"]
                                : styles["rate-low"]
                            }
                          >
                            {customer.deliveryRate.toFixed(1)}%
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          {customer.isRepeatCustomer ? (
                            <span className={styles["badge-repeat"]}>
                              <AiOutlineReload /> Repeat
                            </span>
                          ) : (
                            <span className={styles["badge-new"]}>New</span>
                          )}
                        </TableCell>
                        <TableCell>{formatDate(customer.firstOrderDate)}</TableCell>
                        <TableCell>{formatDate(customer.lastOrderDate)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination Section */}
              <div className={styles["pagination-section"]}>
                <div className={styles["pagination-info"]}>
                  <span>
                    Showing {((page - 1) * limit) + 1} to {Math.min(page * limit, Totalpage || 0)} of {Totalpage || 0} customers
                  </span>
                  <select
                    value={limit}
                    className={styles["limit-select"]}
                    onChange={(e) => {
                      setPageLimit(parseInt(e.target.value));
                      setPage(1);
                    }}
                  >
                    <option value={10}>10 per page</option>
                    <option value={20}>20 per page</option>
                    <option value={50}>50 per page</option>
                    <option value={100}>100 per page</option>
                  </select>
                </div>

                <div className={styles["pagination-controls"]}>
                  <button
                    onClick={() => setPage(1)}
                    disabled={page === 1}
                    className={styles["page-btn"]}
                  >
                    First
                  </button>
                  <button
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                    className={styles["page-btn"]}
                  >
                    Previous
                  </button>

                  <div className={styles["page-numbers"]}>
                    {(() => {
                      const totalPages = Math.max(1, Math.ceil((Totalpage || 0) / limit));
                      const maxButtons = Math.min(5, totalPages);
                      if (maxButtons <= 0) return null;

                      return [...Array(maxButtons)].map((_, idx) => {
                        let pageNum;
                        if (totalPages <= 5) {
                          pageNum = idx + 1;
                        } else if (page <= 3) {
                          pageNum = idx + 1;
                        } else if (page >= totalPages - 2) {
                          pageNum = Math.max(1, totalPages - 4 + idx);
                        } else {
                          pageNum = page - 2 + idx;
                        }

                        return (
                          <button
                            key={`page-${pageNum}`}
                            className={`${styles["page-btn"]} ${
                              page === pageNum ? styles["active"] : ""
                            }`}
                            onClick={() => setPage(pageNum)}
                          >
                            {pageNum}
                          </button>
                        );
                      });
                    })()}
                  </div>

                  <button
                    onClick={() => setPage(page + 1)}
                    disabled={page >= Math.max(1, Math.ceil((Totalpage || 0) / limit))}
                    className={styles["page-btn"]}
                  >
                    Next
                  </button>
                  <button
                    onClick={() => setPage(Math.max(1, Math.ceil((Totalpage || 0) / limit)))}
                    disabled={page >= Math.max(1, Math.ceil((Totalpage || 0) / limit))}
                    className={styles["page-btn"]}
                  >
                    Last
                  </button>
                </div>
              </div>
            </>
          )}

          {/* No Data State */}
          {customers.length === 0 && (
            <div className={styles["shopify-empty-state"]}>
              <AiOutlineUser size={64} />
              <h3>No customer data found</h3>
              <p>Try adjusting your filters or date range</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default CustomerAnalytics;
